export default __webpack_public_path__ + "static/Elido-Bold-d9e72603a47999e83946a10b02b5cc40.woff";